<template>
  <body class="fixed-header" id="#app">
    <login></login>
  </body>
</template>

<script>
  import Login from './Login/Login'

  export default {
    data () {
      return {}
    },

    components: {
      Login
    },

    created () {
      // NOTE: `$router.replace` will not push to history
      this.$router.replace({name: 'login'})
    },

    mounted () {
      this.$nextTick()
      .then(() => {
        document.body.className = ""
        document.body.classList.add(...this.$root.bodyClassList)
      })
    }

  }
</script>



// WEBPACK FOOTER //
// client/components/LoginLayout.vue